import styled from 'styled-components';
import StyledButtonCircleProps from '../interfaces/StyledButtonCircleProps';

const StyledButtonCircle = styled.div<StyledButtonCircleProps>`
  box-sizing: border-box;
  border-radius: 50%;
  border: 7px solid;
  display: flex;
  text-align: center;
  width: 100%;
  max-width: 160px;
  height: 160px;
  justify-content: center;
  margin-bottom: 10px;
  border-color: ${props => props.$circlecolor || '#000'};

  @media screen and (max-height: 759px) {
    width: 100%;
    max-width: 150px;
    height: 150px;
  }

  /* @media screen and (max-height: 859px) {
    width: 100%;
    max-width: 150px;
    height: 150px;
  } */

  /* @media screen and (min-width: 768px) {
    width: 100%;
    max-width: 230px;
    height: 230px;
  } */
  
  /* @media screen and (min-width: 820px) {
    width: 100%;
    max-width: 450px;
    height: 450px;
    border: 15px solid;
    border-color: ${props => props.$circlecolor || '#000'};
  } */
`

export default StyledButtonCircle;